/* eslint-disable @typescript-eslint/camelcase */
import isDomUsable from '@fenderdigital/utils/dom';
import { Cookies } from 'react-cookie';
import { getFlag } from './feature-flags';

export const PLAY_PUBLIC_URL = `${process.env.REACT_APP_CLIENT_FENDER_COM}/play`;
export const PLAY_AUTH_URL = `${process.env.REACT_APP_CLIENT_PLAY_AUTH_URL}`;
export const SSO_URL = `${process.env.REACT_APP_CLIENT_SSO_URL}`;

// clear localstorage auth creds from legacy www.fender.com/connect
// connect.fender.com can't because of the domain difference
export const clearLocalStorage = (): void => window?.localStorage?.clear();

export const asyncClearLocalStorage = (): Promise<void> => {
  return new Promise(resolve => {
    window.localStorage.clear();
    resolve();
  });
};

export const getClientIdCookie = (): Promise<boolean> => {
  const cookies = new Cookies();
  return new Promise(resolve => {
    const clientId = !!cookies.get('lausd-client-id');
    resolve(clientId);
  });
};

export const getSignOutLink = (hasCookie = false): string => {
  return hasCookie
    ? `${process.env.REACT_APP_CLIENT_SSO_URL}/lausd/sign-out`
    : `${process.env.REACT_APP_CLIENT_SSO_URL}/sign-out?ref=${process.env.REACT_APP_CLIENT_FENDER_COM}/play`;
};

/**
 * Add session-started query param for avo event session start on login
 * @returns {string}
 */
export const getSignInUrlWithSession = (): string => {
  const isPlayAuthRedirectEnabled = getFlag('isPlayAuthRedirectEnabled');
  const params = isDomUsable() ? window.location.search : '';
  const parsedParams = params.replace('?clearStorage=true', '');
  const ref = isPlayAuthRedirectEnabled
    ? `${PLAY_AUTH_URL}${parsedParams}`
    : `${PLAY_PUBLIC_URL}${parsedParams}`;

  if (ref.endsWith('?session-started=true')) {
    return `${SSO_URL}/sign-in?ref=${ref}`;
  }

  return `${SSO_URL}/sign-in?ref=${ref}?session-started=true`;
};

export const getSignUpUrlWithSession = (): string => {
  const isPlayAuthRedirectEnabled = getFlag('isPlayAuthRedirectEnabled');
  const params = isDomUsable() ? window.location.search : '';
  const parsedParams = params.replace('?clearStorage=true', '');
  const ref = isPlayAuthRedirectEnabled
    ? `${PLAY_AUTH_URL}${parsedParams}`
    : `${PLAY_PUBLIC_URL}${parsedParams}`;

  if (ref.endsWith('?session-started=true')) {
    return `${SSO_URL}/sign-up?ref=${ref}`;
  }

  return `${SSO_URL}/sign-up?ref=${ref}?session-started=true`;
};

export interface CognitoCredentials {
  token: string;
  userID: string;
  email?: string;
  'first-name': string;
  'last-name': string;
}
